import React from "react"
import { Bar, BarChart, Cell, XAxis, YAxis } from "recharts"
import { getSumDistanceGroupByRace } from "../../api/sync/races"
import "./style.css"

const COLORS = ["#f2749b", "#4b72aa"]

class ProgressChart extends React.Component {
  state = {
    loading: true,
    width: 500,
    groups: []
  }
  componentDidMount() {
    const width = document.documentElement.clientWidth
    if (width <= 500) this.setState({ width: 350 })
    getSumDistanceGroupByRace(this.props.race).then(res => {
      this.setState({ groups: res.data.result })
    })
  }
  render() {
    return (
      <BarChart
        width={this.state.width}
        height={300}
        data={this.state.groups}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <XAxis dataKey="name" />
        <YAxis width={80} unit="KM" />
        <Bar dataKey="sum_distance" barSize={70} fill="#8884d8">
          {this.state.groups.map((entry, index) => {
            const color = COLORS[index]
            return <Cell fill={color} />
          })}
        </Bar>
      </BarChart>
    )
  }
}

export default ProgressChart



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ProgressChart/index.js